angular.module('shared').directive('imageSelect', function() {
  return {
    restrict: 'E',
    template: require('templates/shared/image_select.html.slim'),
    scope: {
      onSelect: '&',
      src: '=',
      maxWidth: '=',
      maxHeight: '=',
      fromAssetLibrary: "=",
      errorText: "@"
    },
    controller: ["$scope", "$timeout", "flash", "AssetLibraryService", function($scope, $timeout, flash, AssetLibraryService) {
      $scope.id = Math.floor(Math.random() * 10000);
      $scope.imageData = {};
      $scope.selectImage = function() {
        if ($scope.errorText) {
          return flash.error = $scope.errorText;
        } else {
          if ($scope.fromAssetLibrary) {
            return AssetLibraryService.open().then(function(image) {
              return $scope.onSelect({
                image: image
              });
            });
          } else {
            angular.element(`#image-select-${$scope.id}`).click();
            return true;
          }
        }
      };
      return $scope.$watch('imageData.file', function(file) {
        var dataUrlReader;
        if (file != null ? file.size : void 0) {
          if (file.size > 5000000) {
            flash.error = 'Image size must be 5MB or lower';
            return;
          }
          dataUrlReader = new window.FileReader();
          dataUrlReader.readAsDataURL(file);
          return dataUrlReader.onloadend = function() {
            return $timeout(function() {
              var image;
              image = dataUrlReader.result.replace(/^data:image\/\w*;base64,/, '');
              return $scope.onSelect({
                image: image,
                preview: dataUrlReader.result
              });
            });
          };
        }
      });
    }]
  };
});
